/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import Datetime from 'react-datetime';
import { BASE_IMAGE_PATH_NEW } from '../../configs/api';
import * as apiOrdersService from '../../services/apiOrdersService'
let linkAllClick;
class BetHistoryCsvAllModal extends Component {
   csvAllLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         loading: false,
         from: "",
         to: "",
         eventType: "SPORTS",
         csv_json: []
      };
   }
   async componentDidMount() {
      // let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      const curDate = new Date().setHours(0, 0, 0, 0)
      const weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ to: curDate, from: weekDate })
   }
   componentWillUnmount(){
      clearTimeout(linkAllClick);
   }
   async onAllDownload() {
      const self = this;
      if(((new Date(this.state.to).getTime()) - (new Date(this.state.from).getTime())) > 86400000){
         this.props.notify("Date range cannot be greater than one day.", "error");
         return false;
      }
      const body = {
         "eventTypeCategory": this.state.eventType,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
     }
     this.setState({loading: true},()=>{
        apiOrdersService.postApiOrderCSVAll(body).then((res) => {
            if (res.isSuccess) {
               this.setState({ csv_json: [] }, () => {
                  let order = res.items
                  let items = []
                  let dictinory = {}
                  for (let x of order) {
                     dictinory = {}
                     let st = x["createdAt"].split(" ")
                     let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                     let dt = new Date(dtstr).toLocaleString("hi-IN")
                     dictinory["Date&Time"] = dt
                     dictinory["User"] = x["username"]
                     dictinory["Competition"] = x["competitionName"]
                     dictinory["Event"] = x["eventName"]
                     dictinory["Market"] = x["marketName"]
                     dictinory["Runner"] = x["runnerName"]
                     if (x["side"] === 0) {
                        dictinory["Side"] = "Back"
                     }
                     else if (x["side"] === 1) {
                        dictinory["Side"] = "Lay"
                     }
                     else if (x["side"] === -1) {
                        dictinory["Side"] = "Unknown"
                     }
                     else {
                        dictinory["Side"] = "-"
                     }
                     if (x["marketBettingType"] === "LINE") {
                        dictinory["Line"] = x["runnerId"]
                     }
                     else {
                        dictinory["Line"] = "-"
                     }
                     dictinory["Rate"] = x["price"]
                     dictinory["Amount"] = x["amount"]
                     if (x["eventTypeId"] === "99") {
                        dictinory["Profit/Loss"] = "-"
                     }
                     else if (x["betStatus"] === "WON") {
                        dictinory["Profit/Loss"] = x["potentialProfit"]
                     }
                     else if (x["betStatus"] === "LOST") {
                        dictinory["Profit/Loss"] = x["potentialLoss"]
                     }
                     else {
                        dictinory["Profit/Loss"] = 0
                     }
                     dictinory["Status"] = x["betStatus"]
                     dictinory["Client IP"] = x["clientIp"]
                     items.push(dictinory)
                  }
                  this.setState({ csv_json: items, loading: false }, () => {
                     linkAllClick = setTimeout(function () {
                        self.csvAllLink.current.link.click();
                     }, 500);
                  })
               })
            }
            else {
               self.props.notify(res.message, "error");
               this.setState({ csv_json: [], loading: false });
            }
         });
      });
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value });
   }
   render() {
      return (
         <>
            <div id="userbook" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
               <div className="modal-dialog  modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">CSV All</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.hidePopup() }}>×</button>
                     </div>
                     <div className="modal-body ac-state" style={{minHeight: "325px"}}>
                        <div className="row mt-2">
                           <div className="col-12 col-sm-4">
                              <div className="form-group font-12">
                                 <Datetime
                                    value={this.state.from}
                                    onChange={(e) => this.onDateTimeChange("from", e)}
                                    id="from_datetime"
                                    dateFormat={"DD/MM/YYYY"}
                                    timeFormat={"HH:mm"}
                                 />
                              </div>
                           </div>
                           <div className="col-12 col-sm-4">
                              <div className="form-group font-12">
                                 <Datetime
                                    value={this.state.to}
                                    onChange={(e) => this.onDateTimeChange("to", e)}
                                    id="to_datetime"
                                    dateFormat={"DD/MM/YYYY"}
                                    timeFormat={"HH:mm"}
                                 />
                              </div>
                           </div>
                           <div className="col-12 col-sm-4">
                              <div className="form-group font-12">
                                 <select title="Event Type" className="form-control" name="eventType" value={this.state.eventType} onChange={(e) => { this.onChange(e) }}>
                                    <option value="SPORTS">Sports</option>
                                    <option value="CASINO">Casino</option>
                                 </select>
                              </div>
                           </div>
                           <div className="col-12">
                              <CSVLink
                                 data={this.state.csv_json}
                                 filename={"Bet History All.csv"}
                                 asyncOnClick={true}
                                 className="d-none"
                                 ref={this.csvAllLink}>
                              </CSVLink>
                              {!this.state.loading && 
                                 <button className="btn btn-primary btn-sm" title="Export Data" onClick={(e) => this.onAllDownload(e)}>
                                    {/* <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img> */}
                                    Download
                                 </button>
                              }
                           </div>
                        </div>
                        { this.state.loading &&
                           <div className='d-flex align-items-center justify-content-center h-75'>
                              <span>
                                 <svg className="spinner mr-2" viewBox="0 0 50 50">
                                    <circle className="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                 </svg>
                                 Downloading...
                              </span>
                           </div>
                        }
                     </div>
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div>
            </div>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(BetHistoryCsvAllModal);